import "./y-axis-bars.scss";

import * as React from "react";

import {ShowHideToggle} from "../../../../../../../../../../../../../common/form/toggles/show-hide-toggle";
import {LpLine} from "../../../../../../../../../../common/left-panel/line/lp-line";
import {scope} from "@common/react/scope";
import {OrientationSelect} from "../../../common/orientation-select";
import {AxisRangeSelect} from "../../../common/axis-range-select";
import {GridStepTypeSelect} from "../../../common/grid-step-type-select";
import {AxisLocationSelect} from "../../../common/axis-location-select";
import {AxisTitle} from "../x-axis/x-axis-rules-comp";
import {YAxisLabel, YGridStepLabel} from "../../../horizontal-bar/panels/y-axis/y-axis-rules-comp";
import {getPath} from "@common/utils/arr-path";
import {CumulativeSelect} from "../../../common/cumulative-select/cumulative-select";
import {AxisScaleSelect} from "../../../common/axis-scale-select";

export const rYAxisBars =
    (fieldsKey) =>
    ({tile, size}) => ({
        getLabel: (getField) =>
            `Y-Axis - Bars - (${fieldsKey
                .split("|")
                .map((f) => getField(f)?.visualNameShort)
                .join(" & ")})`,
        render: () => (
            <div className="combo-chart-y-axis-bars-ss6">
                <div className="subsection">
                    <div className="content">
                        {AxisTitle({
                            tile,
                            size,
                            state: scope(tile, ["style", "yAxisBar", fieldsKey, "label"]),
                        })}
                    </div>
                </div>

                <div className="subsection">
                    {YAxisLabel({
                        tile,
                        size,
                        state: scope(tile, ["style", "yAxisBar", fieldsKey, "labelShown"]),
                    })}
                </div>

                <div className="subsection">
                    <div className="header">Range</div>
                    <div className="content">{AxisRangeSelect(scope(tile, ["style", "yAxisBar", fieldsKey]))}</div>
                </div>

                <div className="subsection">
                    <div className="header">Grid Step</div>
                    <div className="content">
                        {GridStepTypeSelect({
                            state: scope(tile, ["style", "yAxisBar", fieldsKey]),
                            fieldType: "number",
                        })}
                    </div>
                </div>

                <div className="subsection">
                    {YGridStepLabel({
                        tile,
                        size,
                        state: scope(tile, ["style", "yAxisBar", fieldsKey, "gridStepLabelsShown"]),
                    })}

                    {getPath(tile.value, ["style", "yAxisBar", fieldsKey, "gridStepLabelsShown"]) && (
                        <div className="content">{OrientationSelect(scope(tile, ["style", "yAxisBar", fieldsKey, "gridStepLabelOrientation"]))}</div>
                    )}
                </div>

                <div className="subsection">
                    <div className="header">Other Options</div>
                    <div className="content">
                        {/*{MaxValInView(scope(tile, ["style", "yAxisBar", fieldsKey, "maxValuesInViewFixed"]))}*/}

                        {AxisLocationSelect(scope(tile, ["style", "yAxisBar", fieldsKey, "location"]))}

                        {LpLine({
                            label: "Axis Line",
                            control: ShowHideToggle({
                                state: scope(tile, ["style", "yAxisBar", fieldsKey, "lineShown"]),
                            }),
                        })}

                        {LpLine({
                            label: "Grid Lines",
                            control: ShowHideToggle({
                                state: scope(tile, ["style", "yAxisBar", fieldsKey, "gridLinesShown"]),
                            }),
                        })}

                        {AxisScaleSelect(scope(tile, ["style", "yAxisBar", fieldsKey, "logarithmic"]))}

                        {CumulativeSelect({
                            tile,
                            state: scope(tile, ["style", "yAxisBar", fieldsKey, "cumulative"]),
                        })}
                    </div>
                </div>
            </div>
        ),
    });
